import styled from 'styled-components';

export const DayStripWidgetWrapper = styled.div`

`;

export const TitleWrapper = styled.div`
  border-top: 1px solid ${props => props.theme.colors.gray};
  border-bottom: 1px solid ${props => props.theme.colors.gray};
  margin: 0px 0px 10px 0px;
  padding: 10px 0;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid ${props => props.theme.colors.gray};
`;



// WEBPACK FOOTER //
// ./src/containers/GazzanetWidgets/DayWidgetGazzanet/styles.js